import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import { EndpointResponse } from '@/types/endpoints';
import type { Role } from '@/types/user';
import { utils } from '../../utils';
import type { WriteRequestOptions } from '../requestOptions';

type RequestParams = {
  roleData: Partial<Role>;
};

export const createRole = async (scope: RequestScope, { roleData }: RequestParams, options: WriteRequestOptions): Promise<EndpointResponse<Role>> => {
  try {
    const response = await scopedApi(scope).post<EndpointResponse<Role>>('/organization/role', roleData, options);
    return response.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
